
import React, { useEffect, useState } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { preloadRoute, isRoutePreloaded } from '@/utils/routing/routePreloadRegistry';

interface PrefetchLinkProps extends LinkProps {
  prefetch?: boolean | "hover" | "visible";
  prefetchDelay?: number;
}

/**
 * Enhanced Link component that prefetches the target route code when hovered
 */
const PrefetchLink: React.FC<PrefetchLinkProps> = ({
  to,
  prefetch = true,
  prefetchDelay = 100,
  children,
  ...props
}) => {
  const [isPrefetched, setIsPrefetched] = useState(false);
  const path = typeof to === 'string' ? to : to.pathname || '';

  useEffect(() => {
    // Check if already prefetched
    if (isRoutePreloaded(path)) {
      setIsPrefetched(true);
    }
  }, [path]);

  const handlePrefetch = () => {
    if (prefetch === false || isPrefetched) return;

    // Use timeout to avoid prefetching routes the user just passes by
    const timer = setTimeout(() => {
      preloadRoute(path);
      setIsPrefetched(true);
    }, prefetchDelay);

    return () => clearTimeout(timer);
  };

  return (
    <Link
      to={to}
      onMouseEnter={handlePrefetch}
      onFocus={handlePrefetch}
      {...props}
    >
      {children}
    </Link>
  );
};

export default PrefetchLink;
